module.exports = __webpack_public_path__ + "img/图片12.77f97a2e.png";